// function for setting cell color based on percentage //
import React from "react"


const AsPct = ({ val, percision }) => {

    // func for imperceisely handling float-point rounding hell //
    function truncate (num, places) {
        return Math.trunc(num * Math.pow(10, places)) / Math.pow(10, places);
    }

    var textColor = '#000000'
    if (isNaN(parseInt(val))) {
        textColor = '#b8b8b8'
    }

    return (
        <div style={{
            display : 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: textColor
        }}>
            {isNaN(parseFloat(val)) ? '--' : `${truncate(100*val, percision)}%`}
        </div>
    )
    
}

export default AsPct